import { ReactNode } from "react";
import { PermissionRoute } from "./permissionRoute";
import { guardFor } from "./guardedPaths";
import { findEntry } from "../next/routes";

/**
 * The guard of /my-team (in hocs, with the other guards: src/next may not import old code). Today's `PermissionRoute` sends someone without `read_my_team` to their own landing page without a
 * word. Once the switchboard serves the new Team page, that page shows its own "not for you" page instead (board 94: "Only the
 * account owner and managers can manage the team. This link came from an e-mail meant for them."), decided by the server's
 * access answer, so a Team member who opens the e-mailed link learns why. While the old page is served, the old guard stays.
 */
export const TeamGuard = ({ children }: { children: ReactNode }) =>
  findEntry("/my-team")?.entry.mode === "next" ? <>{children}</> : <PermissionRoute {...guardFor("/my-team")}>{children}</PermissionRoute>;
